(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      this.request = null;

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.load();
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }

    // Fetched once: when the section comes near, or before a link to something below it is followed (see below)
    load() {
      if (this.request) return this.request;

      this.request = fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });

      return this.request;
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  // The recommendations are empty until they come near the viewport, and then they push everything below them down: a link to something below
  // them (the reviews link of the product page) scrolled to a place that moved while it was scrolling. They are loaded first, then the page scrolls.
  const loadRecommendationsAbove = (target) => {
    const pending = Array.from(document.querySelectorAll('product-recommendations'))
      .filter(element => !element.request && element.compareDocumentPosition(target) & Node.DOCUMENT_POSITION_FOLLOWING);
    return pending.length ? Promise.all(pending.map(element => element.load())) : null;
  };
  const anchorTarget = (hash) => hash.length > 1 ? document.getElementById(decodeURIComponent(hash.slice(1))) : null;

  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('a[href*="#"]') : null;
    if (!link || event.defaultPrevented || link.pathname !== location.pathname) return;
    const target = anchorTarget(link.hash);
    const loading = target && loadRecommendationsAbove(target);
    if (!loading) return;

    event.preventDefault();
    loading.then(() => requestAnimationFrame(() => {
      target.scrollIntoView({ behavior: 'smooth' });
      history.pushState(null, '', link.hash);
    }));
  });

  // The same for a page that is opened with the hash in the address (the browser has scrolled before the recommendations were loaded)
  window.addEventListener('load', () => {
    const target = anchorTarget(location.hash);
    const loading = target && loadRecommendationsAbove(target);
    if (loading) loading.then(() => requestAnimationFrame(() => target.scrollIntoView()));
  });

  } catch(e) { console.error(e); }
})();
})();
